import React from 'react';
import MaterialModal, { ModalProps } from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    outline: 'none',
  },
}));

const Modal = ({
  children,
  open,
  onBackdropClick,
  disableBackdropClick,
  ...rest
}: ModalProps) => {
  const classes = useStyles();

  return (
    // @ts-ignore
    <MaterialModal
      open={open}
      onBackdropClick={onBackdropClick}
      disableBackdropClick={disableBackdropClick}
      className={classes.modal}
      disableEnforceFocus={true}
      {...rest}
    >
      <Fade in={open}>
        <div className={classes.container}>{children}</div>
      </Fade>
    </MaterialModal>
  );
};

export default Modal;
